import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonComponent, ButtonSize } from '@app/components/button';
import { CardComponent } from '@app/components/card';
import { SpinnerComponent } from '@app/components/spinner';
import { TitleComponent } from '@app/components/title-section';
import { ViewAlign, ViewJustify } from '@app/components/view';
import { AdminTenantService } from '@app/services/admin-tenant/admin-tenant.service';
import { TranslatorService } from '@app/services/translator/translator.service';
import { Spacing } from '@app/shared/types';
import { TranslateModule } from '@ngx-translate/core';
import { EnterpriseTenant, TenantResources } from '@skyfit/core-data-library';
import { filter, switchMap } from 'rxjs';

@Component({
  selector: 'app-resources',
  standalone: true,
  imports: [
    CardComponent,
    ButtonComponent,
    TitleComponent,
    SpinnerComponent,
    TranslateModule,
  ],
  styleUrl: './resources.component.css',
  templateUrl: './resources.component.html',
})
export class ResourcesComponent implements OnInit {
  private readonly adminTenantService = inject(AdminTenantService);
  private readonly translatorService = inject(TranslatorService);
  readonly destroyRef = inject(DestroyRef);
  tenant?: EnterpriseTenant;
  tenantResources?: TenantResources;
  ButtonSize = ButtonSize;
  isLoading = signal(true);
  errorMessage = signal<string | null>(null);
  ViewAlign = ViewAlign;
  ViewJustify = ViewJustify;
  Spacing = Spacing;

  ngOnInit() {
    this.adminTenantService.tenant$
      .pipe(
        filter((tenant): tenant is EnterpriseTenant => !!tenant?.id),
        switchMap((tenant) => {
          this.tenant = tenant;
          return this.adminTenantService.getTenantResources(tenant.id);
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: (tenantResources) => {
          this.isLoading.set(false);
          this.tenantResources = tenantResources;
        },
        error: (error) => {
          const message =
            error?.error?.message ||
            error?.error?.error ||
            'account.resourcesError';
          this.errorMessage.set(this.translatorService.translate(message));
          this.isLoading.set(false);
        },
      });
  }

  openUrl(url: string) {
    window.open(url);
  }
}
